<template>
  <head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.png" rel="shortcut icon">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
          rel="stylesheet">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <div id="content" class="content-minimize">


      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Imprest History</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Imprest</a></li>
                    <li class="breadcrumb-item active">History</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest History Stats -->
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Imprest Requests</p>
                      <h5 class="mb-0">{{ totalImprestRequests }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="mdi mdi-file-document"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Imprest Amount</p>
                      <h5 class="mb-0">{{ formatPrice(totalImprestAmount) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="mdi mdi-cash"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Reconciled Imprest</p>
                      <h5 class="mb-0">{{ reconciledImprestCount }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="mdi mdi-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Pending Requests</p>
                      <h5 class="mb-0">{{ pendingImprestCount }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="mdi mdi-clock-outline"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest History Filters -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="form-label">Date From</label>
                      <input
                          type="date"
                          class="form-control"
                          v-model="filterDateFrom"
                          @change="handleFiltersChanged"
                      >
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Date To</label>
                      <input
                          type="date"
                          class="form-control"
                          v-model="filterDateTo"
                          @change="handleFiltersChanged"
                      >
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Department</label>
                      <select
                          class="form-select"
                          v-model="filterDepartment"
                          @change="handleFiltersChanged"
                      >
                        <option value="">All Departments</option>
                        <option
                            v-for="dept in departments"
                            :key="dept.id"
                            :value="dept.id"
                        >
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Status</label>
                      <select
                          class="form-select"
                          v-model="filterStatus"
                          @change="handleFiltersChanged"
                      >
                        <option value="">All Statuses</option>
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest History Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center">
                  <h5 class="card-title">Imprest History List</h5>
                  <div class="d-flex">
                    <div class="search-box mb-0 me-2">
                      <div class="position-relative">
                        <input
                            type="text"
                            class="form-control bg-light border-light rounded"
                            v-model="search"
                            @input="debounceSearch"
                            placeholder="Search..."
                        >
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                    <button
                        @click="downloadReport"
                        class="btn btn-primary"
                        :disabled="loading"
                    >
                      <i class="mdi mdi-download"></i> Download Report
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <!-- Loading indicator -->
                  <div v-if="loading" class="text-center p-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading imprest records...</p>
                  </div>

                  <!-- Error message -->
                  <div v-else-if="errorMessage" class="alert alert-danger" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    {{ errorMessage }}
                    <button type="button" class="btn btn-sm btn-danger ms-2" @click="fetchImprestHistory">Retry</button>
                  </div>

                  <!-- No results -->
                  <div v-else-if="filteredImprestHistory.length === 0" class="text-center py-4">
                    <i class="mdi mdi-file-search-outline display-4 text-muted"></i>
                    <p class="mt-2">No imprest records found. Try adjusting your filters.</p>
                  </div>

                  <!-- Data table -->
                  <div v-else class="table-responsive">
                    <table class="table table-hover table-striped align-middle">
                      <thead class="table-light">
                      <tr>
                        <th>Imprest ID</th>
                        <th>Purpose</th>
                        <th>Department</th>
                        <th>Requested Amount</th>
                        <th>Actual Expense</th>
                        <th>Request Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="item in filteredImprestHistory"
                          :key="item.id"
                      >
                        <td>{{ item.id }}</td>
                        <td>{{ item.purpose }}</td>
                        <td>{{ item.department.name }}</td>
                        <td>{{ formatPrice(item.requestedAmount) }}</td>
                        <td>{{ formatPrice(item.actualExpense || 0) }}</td>
                        <td>{{ formatDate(item.requestDate) }}</td>
                        <td>
                          <span :class="getStatusBadgeClass(item.status)">
                            {{ formatStatus(item.status) }}
                          </span>
                        </td>
                        <td>
                          <div class="btn-group">
                            <button
                                @click="viewImprestDetails(item)"
                                class="btn btn-info btn-sm"
                                title="View Details"
                            >
                              <i class="mdi mdi-eye"></i>
                            </button>
                            <button
                                v-if="item.status === 'APPROVED' && item.reconciled === 'NO'"
                                @click="reconcileImprest(item.id)"
                                class="btn btn-success btn-sm ms-1"
                                title="Reconcile"
                            >
                              <i class="mdi mdi-check-circle"></i>
                            </button>
                            <button
                                v-if="item.reconciled === 'YES'"
                                class="btn btn-secondary btn-sm ms-1"
                                disabled
                                title="Already Reconciled"
                            >
                              <i class="mdi mdi-check-all"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Showing entries info -->
                  <div class="d-flex justify-content-between align-items-center mt-3">
                    <div v-if="totalItems > 0">
                      Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} entries
                    </div>
                    <div v-else>&nbsp;</div>

                    <!-- Pagination controls -->
                    <div v-if="totalPages > 1">
                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
                            <i class="mdi mdi-chevron-left"></i>
                          </button>
                        </li>
                        <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ active: currentPage === page }">
                          <button class="page-link" @click="goToPage(page)" v-if="page !== '...'">{{ page }}</button>
                          <span class="page-link" v-else>...</span>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
                            <i class="mdi mdi-chevron-right"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Imprest Details Modal -->
    <div class="modal fade" id="imprestDetailsModal" tabindex="-1" aria-labelledby="imprestDetailsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-light">
            <h5 class="modal-title" id="imprestDetailsModalLabel">
              <i class="mdi mdi-file-document-outline me-1"></i> Imprest Details
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-if="selectedImprest">
            <div class="card mb-3">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0">Basic Information</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Imprest ID</small>
                    <strong>{{ selectedImprest.id }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Status</small>
                    <div>
                      <span :class="getStatusBadgeClass(selectedImprest.status)">
                        {{ formatStatus(selectedImprest.status) }}
                      </span>
                      <span v-if="selectedImprest.reconciled === 'YES'" class="badge bg-info ms-2">Reconciled</span>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Requested By</small>
                    <strong>{{ selectedImprest.requester?.name || 'N/A' }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Department</small>
                    <strong>{{ selectedImprest.department?.name || 'N/A' }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Request Date</small>
                    <strong>{{ formatDate(selectedImprest.requestDate) }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Expected Date</small>
                    <strong>{{ formatDate(selectedImprest.expectedDate) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0">Purpose & Amount</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <small class="text-muted d-block">Purpose</small>
                    <strong>{{ selectedImprest.purpose }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Requested Amount</small>
                    <strong class="text-primary">{{ formatPrice(selectedImprest.requestedAmount) }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Actual Expense</small>
                    <strong v-if="selectedImprest.actualExpense" class="text-success">{{ formatPrice(selectedImprest.actualExpense) }}</strong>
                    <span v-else class="text-muted">Not yet reconciled</span>
                  </div>
                  <div class="col-md-12" v-if="selectedImprest.notes">
                    <small class="text-muted d-block">Notes</small>
                    <p class="mb-0">{{ selectedImprest.notes }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-3" v-if="selectedImprest.status !== 'PENDING'">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0">Processing Details</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div v-if="selectedImprest.status === 'APPROVED'" class="col-md-6 mb-3">
                    <small class="text-muted d-block">Approved By</small>
                    <strong>{{ selectedImprest.approverId || 'N/A' }}</strong>
                  </div>
                  <div v-if="selectedImprest.status === 'APPROVED'" class="col-md-6 mb-3">
                    <small class="text-muted d-block">Approval Date</small>
                    <strong>{{ formatDateTime(selectedImprest.approvalDate) || 'N/A' }}</strong>
                  </div>
                  <div v-if="selectedImprest.status === 'REJECTED'" class="col-md-6 mb-3">
                    <small class="text-muted d-block">Rejected By</small>
                    <strong>{{ selectedImprest.approverId || 'N/A' }}</strong>
                  </div>
                  <div v-if="selectedImprest.status === 'REJECTED'" class="col-md-6 mb-3">
                    <small class="text-muted d-block">Rejection Date</small>
                    <strong>{{ formatDateTime(selectedImprest.rejectionDate) || 'N/A' }}</strong>
                  </div>
                  <div v-if="selectedImprest.status === 'REJECTED' && selectedImprest.rejectionReason" class="col-md-12">
                    <small class="text-muted d-block">Rejection Reason</small>
                    <p class="mb-0 text-danger">{{ selectedImprest.rejectionReason }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-3" v-if="selectedImprest.reconciled === 'YES'">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0">Reconciliation Details</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Reconciled By</small>
                    <strong>{{ selectedImprest.reconciledBy || 'N/A' }}</strong>
                  </div>
                  <div class="col-md-6 mb-3">
                    <small class="text-muted d-block">Reconciliation Date</small>
                    <strong>{{ formatDateTime(selectedImprest.reconciliationDate) || 'N/A' }}</strong>
                  </div>
                  <div class="col-md-12" v-if="selectedImprest.reconciliationDetails">
                    <small class="text-muted d-block">Expense Breakdown</small>
                    <div class="bg-light p-3 rounded mt-2">
                      <pre class="mb-0" style="white-space: pre-wrap;">{{ selectedImprest.reconciliationDetails }}</pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card" v-if="selectedImprest.attachments && selectedImprest.attachments.length > 0">
              <div class="card-header bg-light py-2">
                <h6 class="mb-0">Attachments</h6>
              </div>
              <div class="card-body">
                <div class="d-flex flex-wrap gap-2">
                  <div v-for="(attachment, index) in selectedImprest.attachments" :key="index" class="border p-2 rounded">
                    <a :href="getPathUrl(attachment.url)" target="_blank" class="d-flex align-items-center">
                      <i class="mdi mdi-file-pdf me-1 text-danger"></i> {{ attachment.name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button
                v-if="selectedImprest && selectedImprest.status === 'APPROVED' && selectedImprest.reconciled === 'NO'"
                type="button"
                class="btn btn-success"
                @click="reconcileImprest(selectedImprest.id)"
            >
              <i class="mdi mdi-check-circle me-1"></i> Reconcile
            </button>
            <button
                v-if="selectedImprest && selectedImprest.reconciled === 'YES'"
                type="button"
                class="btn btn-primary"
                @click="printImprestDetails"
            >
              <i class="mdi mdi-printer me-1"></i> Print
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  </body>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import NavigationBar from "@/components/Navigation.vue";
import { execute, authUrl } from "@/api";
import router from "@/router";

export default {
  name: 'ImprestHistory',
  components: {NavigationBar},
  data() {
    return {
      // Search and Filter
      search: '',
      filterDateFrom: '',
      filterDateTo: '',
      filterDepartment: '',
      filterStatus: '',

      // Statistics
      totalImprestRequests: 0,
      totalImprestAmount: 0,
      reconciledImprestCount: 0,
      pendingImprestCount: 0,

      // Departments for filtering
      departments: [],

      // Imprest History Data
      imprestHistory: [],
      filteredImprestHistory: [], // To hold filtered data
      selectedImprest: null,
      currentUser: 'Demo User', // Replace with actual logged-in user
      apiResponse: null, // Store the entire API response

      // Pagination
      currentPage: 1,
      pageSize: 10,
      totalPages: 0,
      totalItems: 0,

      // Loading and Error Handling
      loading: false,
      errorMessage: '',

      // Search debounce
      searchTimeout: null
    }
  },
  computed: {
    // Calculate visible page numbers for pagination
    visiblePages() {
      const pages = [];
      const maxVisiblePages = 5;

      if (this.totalPages <= maxVisiblePages) {
        // Show all pages if total pages are less than or equal to maxVisiblePages
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Always show first page
        pages.push(1);

        // Calculate middle pages
        let startPage = Math.max(2, this.currentPage - 1);
        let endPage = Math.min(this.totalPages - 1, this.currentPage + 1);

        // Adjust if we're at the beginning or end
        if (this.currentPage <= 2) {
          endPage = 4;
        } else if (this.currentPage >= this.totalPages - 1) {
          startPage = this.totalPages - 3;
        }

        // Add ellipsis if needed after first page
        if (startPage > 2) {
          pages.push('...');
        }

        // Add middle pages
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        // Add ellipsis if needed before last page
        if (endPage < this.totalPages - 1) {
          pages.push('...');
        }

        // Always show last page
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  mounted() {
    // Single call to fetch all data in sequence
    this.initialLoad();
  },
  methods: {
    // Load data in sequence to prevent race conditions
    async initialLoad() {
      try {
        this.loading = true;
        this.errorMessage = '';

        // Fetch all imprest history data
        await this.fetchImprestHistory();

        this.loading = false;
      } catch (error) {
        console.error('Error during initial load:', error);
        this.errorMessage = 'Failed to load data. Please try again later.';
        this.loading = false;
      }
    },

    // API Calls
    async fetchImprestHistory() {
      try {
        this.loading = true;
        this.errorMessage = '';

        const data = new FormData();
        data.append("function", "getImprestHistory");
        data.append("page", this.currentPage);
        data.append("pageSize", this.pageSize);

        // Add filter parameters if they exist
        if (this.search) data.append("search", this.search);
        if (this.filterDepartment) data.append("departmentId", this.filterDepartment);
        if (this.filterStatus) data.append("status", this.filterStatus);
        if (this.filterDateFrom) data.append("fromDate", this.filterDateFrom);
        if (this.filterDateTo) data.append("toDate", this.filterDateTo);

        const response = await execute(data, authUrl);

        // Store the entire response for statistics processing
        this.apiResponse = response.data;

        if (response.data.success) {
          // Get the imprest history array from the response
          const imprestData = response.data.data.imprestHistory || [];

          // Map the data to match our component's expected format
          this.imprestHistory = imprestData.map(item => ({
            id: item.request_id,
            purpose: item.purpose,
            department: {
              id: item.department_id,
              name: item.department
            },
            requestedAmount: parseFloat(item.amount),
            actualExpense: item.actual_expense ? parseFloat(item.actual_expense) : null,
            requestDate: item.request_date,
            expectedDate: item.expected_date,
            status: item.status.toUpperCase(),
            reconciled: item.reconciled,
            requester: {
              id: item.requester_id,
              name: item.names
            },
            notes: item.notes,
            approverId: item.approver_id,
            approvalDate: item.approval_date,
            rejectionReason: item.rejection_reason,
            rejectionDate: item.rejection_date,
            reconciledBy: item.reconciled_by,
            reconciliationDate: item.reconciliation_date,
            reconciliationDetails: item.reconciliation_details,
            attachments: item.attachments ? JSON.parse(item.attachments).map(path => ({
              url: path,
              name: path.split('/').pop()
            })) : []
          }));

          // Set filteredImprestHistory to the mapped data
          this.filteredImprestHistory = [...this.imprestHistory];

          // Get pagination details from response if available
          if (response.data.data.pagination) {
            this.totalItems = response.data.data.pagination.total || imprestData.length;
            this.totalPages = response.data.data.pagination.pages || Math.ceil(this.totalItems / this.pageSize);
          } else {
            // Fallback to client-side pagination if server doesn't provide it
            this.totalItems = imprestData.length;
            this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          }

          // Process statistics after data is loaded
          this.processStatistics();

          // Extract unique departments for filter dropdown
          this.extractDepartments(imprestData);
        } else {
          console.error("Error fetching imprest history:", response.data.message);
          this.errorMessage = response.data.message || 'Failed to load imprest history. Please try again later.';
          this.imprestHistory = [];
          this.filteredImprestHistory = [];
        }
      } catch (error) {
        console.error('Error fetching imprest history:', error);
        this.errorMessage = 'Failed to load imprest history. Please try again later.';
        this.imprestHistory = [];
        this.filteredImprestHistory = [];
      } finally {
        this.loading = false;
      }
    },


    getPathUrl(path) {
      return authUrl+''+path;
    },

    // Extract departments from imprest data
    extractDepartments(imprestData) {
      const uniqueDepartments = [];
      const departmentIds = new Set();

      imprestData.forEach(item => {
        if (item.department_id && !departmentIds.has(item.department_id)) {
          departmentIds.add(item.department_id);
          uniqueDepartments.push({
            id: item.department_id,
            name: item.department
          });
        }
      });

      this.departments = uniqueDepartments;
    },

    // Process statistics from imprest history data
    processStatistics() {
      try {
        // Get metrics from the API response if available
        if (this.apiResponse && this.apiResponse.data && this.apiResponse.data.metrics) {
          const metrics = this.apiResponse.data.metrics;

          // Set the statistics from the metrics object
          this.totalImprestRequests = parseInt(metrics.totalRequests || 0);
          this.totalImprestAmount = parseFloat(metrics.totalAmount || 0);
          this.reconciledImprestCount = parseInt(metrics.reconciled || 0);
          this.pendingImprestCount = parseInt(metrics.pending || 0);
        } else {
          // Calculate from all imprest records (not just current page)
          const allImprestData = this.apiResponse?.data?.data?.imprestHistory || [];

          // Set total requests count
          this.totalImprestRequests = allImprestData.length;

          // Calculate total amount
          this.totalImprestAmount = allImprestData.reduce((total, item) => {
            return total + (parseFloat(item.amount) || 0);
          }, 0);

          // Count reconciled imprest requests
          this.reconciledImprestCount = allImprestData.filter(item =>
              item.reconciled === 'YES'
          ).length;

          // Count pending requests
          this.pendingImprestCount = allImprestData.filter(item =>
              item.status.toUpperCase() === 'PENDING'
          ).length;
        }
      } catch (error) {
        console.error('Error processing statistics:', error);
        // Set default values if calculation fails
        this.totalImprestRequests = 0;
        this.totalImprestAmount = 0;
        this.reconciledImprestCount = 0;
        this.pendingImprestCount = 0;
      }
    },

    formatStatus(status) {
      // Capitalize the first letter and lowercase the rest
      return status.charAt(0) + status.slice(1).toLowerCase();
    },

    async downloadReport() {
      try {
        this.loading = true;

        const data = new FormData();
        data.append("function", "generateImprestReport");
        data.append("reportType", "PDF");

        // Add filter parameters if they exist
        if (this.search) data.append("search", this.search);
        if (this.filterDepartment) data.append("departmentId", this.filterDepartment);
        if (this.filterStatus) data.append("status", this.filterStatus);
        if (this.filterDateFrom) data.append("fromDate", this.filterDateFrom);
        if (this.filterDateTo) data.append("toDate", this.filterDateTo);

        const response = await execute(data, authUrl, { responseType: 'blob' });

        if (response.data) {
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Imprest_Report_${new Date().toISOString().split('T')[0]}.pdf`);
          document.body.appendChild(link);
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
        } else {
          console.error('Error downloading report: Empty response');
          this.$toast.error('Failed to download report. Please try again later.');
        }
      } catch (error) {
        console.error('Error downloading report:', error);
        this.$toast.error('Failed to download report. Please try again later.');
      } finally {
        this.loading = false;
      }
    },

    async reconcileImprest(imprestId) {

        const confirmAction = confirm('Are you sure you want to reconcile this imprest?');
        if (!confirmAction) return;
        sessionStorage.setItem('imprestId', imprestId);
        await router.push('imprest-reconciliation')


    },

    async viewImprestDetails(item) {
      try {
        // Set the selected imprest directly from the row data
        this.selectedImprest = item;

        // Show modal
        const modalElement = document.getElementById('imprestDetailsModal');
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      } catch (error) {
        console.error('Error showing imprest details:', error);
        alert('Failed to display imprest details. Please try again later.');
      }
    },

    // Utility Methods
    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD MMM YYYY HH:mm');
    },

    getStatusBadgeClass(status) {
      const statusClasses = {
        'PENDING': 'badge bg-warning text-dark',
        'APPROVED': 'badge bg-success',
        'REJECTED': 'badge bg-danger',
        'RECONCILED': 'badge bg-info'
      };
      return statusClasses[status] || 'badge bg-secondary';
    },

    printImprestDetails() {
      // Open a new window for printing
      const printWindow = window.open('', '_blank');

      // Generate print content
      let printContent = `
        <html>
        <head>
          <title>Imprest Details - ${this.selectedImprest.id}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .header { text-align: center; margin-bottom: 20px; }
            .header h2 { margin-bottom: 5px; }
            .section { margin-bottom: 20px; }
            .section-title { background-color: #f0f0f0; padding: 5px 10px; font-weight: bold; margin-bottom: 10px; }
            .row { display: flex; margin-bottom: 10px; }
            .col { flex: 1; padding-right: 15px; }
            .label { font-weight: bold; margin-bottom: 5px; }
            .value { margin-bottom: 5px; }
            .badge { display: inline-block; padding: 3px 8px; border-radius: 3px; font-size: 12px; }
            .badge-success { background-color: #28a745; color: white; }
            .badge-warning { background-color: #ffc107; color: #212529; }
            .badge-danger { background-color: #dc3545; color: white; }
            .badge-info { background-color: #17a2b8; color: white; }
            .pre-box { background-color: #f8f9fa; padding: 10px; white-space: pre-wrap; }
            table { width: 100%; border-collapse: collapse; }
            table, th, td { border: 1px solid #ddd; }
            th, td { padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>Imprest Details</h2>
            <p>Reference: ${this.selectedImprest.id}</p>
          </div>

          <div class="section">
            <div class="section-title">Basic Information</div>
            <div class="row">
              <div class="col">
                <div class="label">Status</div>
                <div class="value">
                  <span class="badge badge-${this.getStatusClass(this.selectedImprest.status)}">
                    ${this.formatStatus(this.selectedImprest.status)}
                  </span>
                  ${this.selectedImprest.reconciled === 'YES' ? '<span class="badge badge-info">Reconciled</span>' : ''}
                </div>
              </div>
              <div class="col">
                <div class="label">Requested By</div>
                <div class="value">${this.selectedImprest.requester?.name || 'N/A'}</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="label">Department</div>
                <div class="value">${this.selectedImprest.department?.name || 'N/A'}</div>
              </div>
              <div class="col">
                <div class="label">Request Date</div>
                <div class="value">${this.formatDate(this.selectedImprest.requestDate)}</div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="section-title">Purpose & Amount</div>
            <div class="row">
              <div class="col">
                <div class="label">Purpose</div>
                <div class="value">${this.selectedImprest.purpose}</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="label">Requested Amount</div>
                <div class="value">${this.formatPrice(this.selectedImprest.requestedAmount)}</div>
              </div>
              <div class="col">
                <div class="label">Actual Expense</div>
                <div class="value">${this.selectedImprest.actualExpense ? this.formatPrice(this.selectedImprest.actualExpense) : 'Not reconciled'}</div>
              </div>
            </div>
            ${this.selectedImprest.notes ? `
            <div class="row">
              <div class="col">
                <div class="label">Notes</div>
                <div class="value">${this.selectedImprest.notes}</div>
              </div>
            </div>
            ` : ''}
          </div>
      `;

      // Add reconciliation details if reconciled
      if (this.selectedImprest.reconciled === 'YES') {
        printContent += `
          <div class="section">
            <div class="section-title">Reconciliation Details</div>
            <div class="row">
              <div class="col">
                <div class="label">Reconciled By</div>
                <div class="value">${this.selectedImprest.reconciledBy || 'N/A'}</div>
              </div>
              <div class="col">
                <div class="label">Reconciliation Date</div>
                <div class="value">${this.formatDateTime(this.selectedImprest.reconciliationDate) || 'N/A'}</div>
              </div>
            </div>
            ${this.selectedImprest.reconciliationDetails ? `
            <div class="row">
              <div class="col">
                <div class="label">Expense Breakdown</div>
                <div class="pre-box">${this.selectedImprest.reconciliationDetails}</div>
              </div>
            </div>
            ` : ''}
          </div>
        `;
      }

      // Close the HTML document
      printContent += `
          <div class="section">
            <div class="section-title">Authentication</div>
            <p>Printed on: ${new Date().toLocaleString()}</p>
            <p>Printed by: ${this.currentUser || 'System User'}</p>
          </div>
        </body>
        </html>
      `;

      // Write to the new window and print
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();

      // Wait for content to load then print
      printWindow.onload = function() {
        printWindow.print();
      };
    },

    getStatusClass(status) {
      const statusClasses = {
        'PENDING': 'warning',
        'APPROVED': 'success',
        'REJECTED': 'danger',
        'RECONCILED': 'info'
      };
      return statusClasses[status] || 'secondary';
    },

    // Pagination
    goToPage(page) {
      if (page === '...') return;

      this.currentPage = page;
      this.fetchImprestHistory();
    },

    // Debounce search to avoid too many API calls
    debounceSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1; // Reset to first page when searching
        this.fetchImprestHistory();
      }, 500);
    },

    // Handle filter changes
    handleFiltersChanged() {
      this.currentPage = 1; // Reset to first page when filters change
      this.fetchImprestHistory();
    }
  }
}
</script>

<style scoped>
/* Add any component-specific styles here */
.page-link {
  cursor: pointer;
}
</style>